import { render, staticRenderFns } from "./CallbackView.vue?vue&type=template&id=281e064f"
import script from "./CallbackView.vue?vue&type=script&lang=ts"
export * from "./CallbackView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports